// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_look */
var FoodSensoryLook;
(function (FoodSensoryLook) {
    FoodSensoryLook["everyday"] = "everyday";
    FoodSensoryLook["showcase"] = "showcase";
})(FoodSensoryLook || (FoodSensoryLook = {}));
;
export default FoodSensoryLook;
/** Zod schema for food_sensory_look */
export const foodSensoryLook = z.nativeEnum(FoodSensoryLook);
//# sourceMappingURL=FoodSensoryLook.js.map